import React, { useRef, useState } from 'react'
import PageTitle from 'components/PageTitle'
import { ErrorMessage, Field, Form, Formik } from 'formik'
import * as Yup from 'yup'
import emailjs from '@emailjs/browser';
import { BiMailSend } from 'react-icons/bi'
import Loading from 'components/Loading'

const Contact = () => {
  const formRef = useRef();
  const [successSend, setSuccessSend] = useState(false)
  const [fullname, setfullname] = useState('')


  // Contact form intial Values
  const initialValues = {
    firstname: '',
    lastname: '',
    email: '',
    subject: '',
    message: '',
  };

  // Form validation schema using Yup
  const LoginSchema = Yup.object().shape({
    firstname: Yup.string().required("Please enter your First name.").min(2, "Name must be 2 characters at minimum"),
    lastname: Yup.string().required("Please enter your Last name.").min(2, "Name must be 2 characters at minimum"),
    email: Yup.string()
      .email("Invalid email address format")
      .required("Email is required"),
    subject: Yup.string()
      .min(10, "Mail subject must be 10 characters at minimum")
      .required("Mail subject is required"),
    message: Yup.string()
      .min(25, "Message must be 25 characters at minimum")
      .required("Message is required"),
  });

  //  Emailjs send function
  const sendEmail = () => {
    return emailjs.sendForm('desgbr', 'desgbr-form', formRef.current, 'pC07XbuWoa5AMULuA')
  }

// hide alert popup after 5 seconds
  successSend && setTimeout(() => { setSuccessSend(false) }, 5000);

  return (
    <section className='contact-page'>
      <PageTitle title='Contact me' />
      <div className="top-title">
        <p>
          I'm always open to discussing
        </p>
        <span>Web development solutions</span>
        <span>UI/UX design solutions</span>
        <span>Graphic designs solutions</span>
        <p>
          Feel free to send a message to me 😍
        </p>
      </div>


      <Formik
        initialValues={initialValues}
        validationSchema={LoginSchema}
        onSubmit={(values, { resetForm, setSubmitting }) =>{
          setSubmitting(true)
          sendEmail()
            .then((result) => {
              result.text === 'OK' ? setSuccessSend(true) : setSuccessSend(false)
              setfullname(values.firstname + ' ' + values.lastname)
              setSubmitting(false)
              resetForm()
            }, (error) => {
              console.log(error.text);
              setSubmitting(false)
            });
        }}
      >
        {({ isSubmitting, values }) => (
          <Form ref={formRef}>
            <div>
              <label htmlFor="">First Name</label>
              <Field value={values.firstname} name='firstname' type="text" placeholder='first name...' className="form-control" />
              <ErrorMessage component="span" name="firstname" className="error" />
            </div>
            <div>
              <label htmlFor="">Last Name</label>
              <Field value={values.lastname} name='lastname' type="text" placeholder='Last name...' className="form-control" />
              <ErrorMessage component="span" name="lastname" className="error" />
            </div>
            <div>
              <label htmlFor="">Mail Subject</label>
              <Field value={values.subject} name='subject' type="text" placeholder='Mail subject...' className="form-control" />
              <ErrorMessage component="span" name="subject" className="error" />
            </div>
            <div>
              <label htmlFor="">Email Address</label>
              <Field value={values.email} name='email' type="text" placeholder='Email Address...' className="form-control" />
              <ErrorMessage component="span" name="email" className="error" />
            </div>
            <div>
              <label htmlFor="">Message</label>
              <Field value={values.message} name="message" component="textarea" cols="30" rows="10" className="form-control"
                placeholder='Write your message content...'
              />
              <ErrorMessage
                component="span"
                name="message"
                className="error"
              />
            </div>

            <button type='submit' disabled={isSubmitting}>
              {
                isSubmitting ?
                <>
                  <Loading width="40" height="40" stroke="#FFF" />
                  <span>Sending...</span>
                </> :
                <>
                  <BiMailSend size="1.4rem" />
                  <span>Send message</span>
                  </>
                }
            </button>
            </Form>
        )
      }

      </Formik>
      {
        successSend && <div className="sent">
          <p>
            Thank you
            <span>{fullname}</span>
            😍😍,
            we got your message and we'll be in touch ASAP 🧑‍💻.
          </p>
        </div>
      }

    </section>
  )
}

export default Contact